import { useAuth } from "@/contexts/AuthContext";
import { AdvisorDashboard } from "@/components/roles/AdvisorDashboard";
import { ClientDashboard } from "@/components/roles/ClientDashboard";
import { ExecutorDashboard } from "@/components/roles/ExecutorDashboard";
import { AdministratorDashboard } from "@/components/roles/AdministratorDashboard";
import { useUploadEventStream } from "@/hooks/useUploadEvents";

export function AppShell() {
  const { user } = useAuth();

  // One app-level SSE stream for the authenticated session (live upload updates).
  useUploadEventStream();

  if (!user) {
    return null;
  }

  let dashboard: React.ReactNode;
  switch (user.role) {
    case "advisor":
      dashboard = <AdvisorDashboard />;
      break;
    case "client":
      dashboard = <ClientDashboard />;
      break;
    case "executor":
      dashboard = <ExecutorDashboard />;
      break;
    case "administrator":
      dashboard = <AdministratorDashboard />;
      break;
    default:
      dashboard = (
        <div className="flex items-center justify-center min-h-screen">
          <p className="text-destructive">Invalid user role</p>
        </div>
      );
  }

  return <>{dashboard}</>;
}
